import { Typography } from '@tempmee/react';
import { Box } from '../Box';
import { Column } from '../Column';
import { Row } from '../Row';
import { ILegalDocumentNode } from './Types';

interface ILegalDocumentProps {
  content: ILegalDocumentNode;
  depth?: number;
  indent?: number;
}

export const LegalDocumentItem = ({ content, depth = 0, indent = 24 }: ILegalDocumentProps) => {
  return (
    <Column marginBottom={20}>
      <Row gap={16} paddingLeft={depth * indent}>
        <Box minWidth={24}>
          <Typography as="span">{content.id}.</Typography>
        </Box>
        <Box flex={1}>
          <Typography as="span" textAlign="justify">
            {content.title.length > 0 && (
              <Typography as="span" style={{ textDecoration: 'underline' }}>
                {content.title}:
              </Typography>
            )}{' '}
            {content.description}
          </Typography>
        </Box>
      </Row>
      {content.children?.map((it) => (
        <LegalDocumentItem key={it.id} content={it} depth={1} indent={indent + 16} />
      ))}
    </Column>
  );
};
